// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as LumiPTZ from "lumi-rescript/lib/es6/src/LumiPTZ.res.js";
import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiSort from "lumi-sort/lib/es6/src/LumiSort.res.js";
import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Rectf$Linear from "lumi-linear/lib/es6/src/Rectf.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Belt_MapString from "@rescript/runtime/lib/es6/Belt_MapString.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Camera$LumiDocuments from "lumi-documents/lib/es6/src/Camera.res.js";
import * as Sensor$LumiDocuments from "lumi-documents/lib/es6/src/Sensor.res.js";
import * as Scale$LumiFacilityMap from "./Scale.res.js";
import * as Indicator$LumiDocuments from "lumi-documents/lib/es6/src/Indicator.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as FacilityMap$LumiDocuments from "lumi-documents/lib/es6/src/FacilityMap.res.js";
import * as MapObject$LumiFacilityMap from "./MapObject.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";
import * as CameraObject$LumiFacilityMap from "./CameraObject.res.js";
import * as DisplayStyle$LumiFacilityMap from "./DisplayStyle.res.js";
import * as DisplayObject$LumiFacilityMap from "./DisplayObject.res.js";
import * as ObjectStyleMap$LumiFacilityMap from "./ObjectStyleMap.res.js";
import * as DisplayStyleMap$LumiFacilityMap from "./DisplayStyleMap.res.js";
import * as IndicatorObject$LumiFacilityMap from "./IndicatorObject.res.js";

let SensorStyles = ObjectStyleMap$LumiFacilityMap.Make(Sensor$LumiDocuments.Schema.CmpKey);

let CameraStyles = ObjectStyleMap$LumiFacilityMap.Make(Camera$LumiDocuments.Schema.CmpKey);

let IndicatorStyles = ObjectStyleMap$LumiFacilityMap.Make(Indicator$LumiDocuments.Schema.CmpKey);

function calculateScale(facilityMap) {
  return Stdlib_Option.getOr(facilityMap.scale, Stdlib_Option.getOr(Stdlib_Array.findMap(Belt_MapString.valuesToArray(facilityMap.objects), param => {
    let objectType = param.objectType;
    if (objectType.TAG !== "ParkingPlace") {
      return;
    }
    let shape = objectType.shape;
    if (shape.TAG === "Rectangle") {
      return Scale$LumiFacilityMap.fromShape(shape);
    }
  }), Scale$LumiFacilityMap.default));
}

function defaultOnClick(param, param$1, param$2) {
  
}

function $$Map(props) {
  let mbOnClickIndicator = props.onClickIndicator;
  let mbOnClickDisplay = props.onClickDisplay;
  let mbOnClickCamera = props.onClickCamera;
  let mbOnClickParkingPlace = props.onClickParkingPlace;
  let mbOnClickSlope = props.onClickSlope;
  let mbOnSvgElement = props.onSvgElement;
  let __panButton = props.panButton;
  let __indicatorStyles = props.indicatorStyles;
  let __displayStyles = props.displayStyles;
  let __cameraStyles = props.cameraStyles;
  let __sensorStyles = props.sensorStyles;
  let __svgStyles = props.svgStyles;
  let __showLayer = props.showLayer;
  let __setMapTransform = props.setMapTransform;
  let __mapTransform = props.mapTransform;
  let facilityMap = props.facilityMap;
  let mapTransform = __mapTransform !== undefined ? __mapTransform : Transform$Linear.M23f.identity;
  let setMapTransform = __setMapTransform !== undefined ? __setMapTransform : param => {};
  let showLayer = __showLayer !== undefined ? __showLayer : param => true;
  let svgStyles = __svgStyles !== undefined ? Primitive_option.valFromOption(__svgStyles) : undefined;
  let sensorStyles = __sensorStyles !== undefined ? Primitive_option.valFromOption(__sensorStyles) : SensorStyles.empty;
  let cameraStyles = __cameraStyles !== undefined ? Primitive_option.valFromOption(__cameraStyles) : CameraStyles.empty;
  let displayStyles = __displayStyles !== undefined ? Primitive_option.valFromOption(__displayStyles) : DisplayStyleMap$LumiFacilityMap.empty;
  let indicatorStyles = __indicatorStyles !== undefined ? Primitive_option.valFromOption(__indicatorStyles) : IndicatorStyles.empty;
  let panButton = __panButton !== undefined ? __panButton : "Secondary";
  let aabb = Rectf$Linear.scaleCenter(FacilityMap$LumiDocuments.FacilityMap.axisAlignedBoundingBox(facilityMap), 1.05);
  let svgRef = React.useRef(null);
  let getPointerPosition = e => LumiSVG.pointerEventToViewportCoordinates(e, Stdlib_Nullable.getOrThrow(svgRef.current));
  let ptz = LumiPTZ.usePTZ(mapTransform, setMapTransform, panButton, getPointerPosition);
  let scale = calculateScale(facilityMap);
  let getObjectStyle = (svgId, objectType) => {
    let mbObjectStyle;
    switch (objectType.TAG) {
      case "ParkingPlace" :
        mbObjectStyle = Stdlib_Option.flatMap(objectType.linkedSensor, key => Belt_Map.get(sensorStyles, key));
        break;
      case "Camera" :
        mbObjectStyle = Stdlib_Option.flatMap(objectType.linkedCamera, key => Belt_Map.get(cameraStyles, key));
        break;
      case "Display" :
        mbObjectStyle = Stdlib_Option.map(Stdlib_Option.flatMap(objectType.linkedDisplay, key => Belt_Map.get(displayStyles, key)), style => style.objectStyle);
        break;
      case "Indicator" :
        mbObjectStyle = Stdlib_Option.flatMap(objectType.linkedIndicator, key => Belt_Map.get(indicatorStyles, key));
        break;
      default:
        mbObjectStyle = undefined;
    }
    return ObjectStyle$LumiFacilityMap.mergeOpt(mbObjectStyle, Belt_MapString.get(svgStyles, svgId));
  };
  let layers = LumiSort.stableSortOn(LumiArray.groupBy(Belt_MapString.toArray(facilityMap.objects), param => FacilityMap$LumiDocuments.ObjectType.toEnum(param[1].objectType)), param => FacilityMap$LumiDocuments.ObjectType.Enum.toDrawingOrder(param[0]));
  return JsxRuntime.jsx("svg", {
    children: JsxRuntime.jsxs("g", {
      children: [
        LumiReact.renderOption(undefined, props.svgDefs, svgDefs => JsxRuntime.jsx("defs", {
          children: svgDefs
        })),
        layers.filter(param => showLayer(param[0])).map(param => {
          let objectTypeEnum = param[0];
          return JsxRuntime.jsx("g", {
            children: LumiSort.stableSortOn(param[1], param => {
              let svgId = param[0];
              let objectType = param[1].objectType;
              return Stdlib_Option.getOr(Stdlib_Option.flatMap(getObjectStyle(svgId, objectType), style => style.order), 0);
            }).map(param => {
              let match = param[1];
              let svgId = param[0];
              let transform = match.transform;
              let objectType = match.objectType;
              let svgStyle = Belt_MapString.get(svgStyles, svgId);
              let mkMapObject = (shape, objectStyle, fitLabelOpt, onClick) => {
                let fitLabel = fitLabelOpt !== undefined ? fitLabelOpt : false;
                return JsxRuntime.jsx(MapObject$LumiFacilityMap.make, {
                  mapTransform: mapTransform,
                  objectTransform: transform,
                  shape: shape,
                  objectStyle: ObjectStyle$LumiFacilityMap.mergeOpt(objectStyle, svgStyle),
                  fitLabel: fitLabel,
                  scale: scale,
                  onClick: onClick
                }, svgId);
              };
              switch (objectType.TAG) {
                case "Area" :
                  return mkMapObject(objectType.shape, ObjectStyle$LumiFacilityMap.make(objectType.name, undefined, undefined, undefined, undefined, undefined), undefined, undefined);
                case "Slope" :
                  let linkedMap = objectType.linkedMap;
                  return mkMapObject(objectType.shape, undefined, undefined, Stdlib_Option.map(mbOnClickSlope, onClickSlope => LumiReact.nonPropagatedMouseEvent(__x => onClickSlope(__x, svgId, Stdlib_Option.map(linkedMap, Document$LumiStore.Key.coerce)))));
                case "ParkingPlace" :
                  let linkedSensor = objectType.linkedSensor;
                  return mkMapObject(objectType.shape, Stdlib_Option.flatMap(linkedSensor, sensorKey => Belt_Map.get(sensorStyles, sensorKey)), true, Stdlib_Option.map(mbOnClickParkingPlace, onClickParkingPlace => LumiReact.nonPropagatedMouseEvent(__x => onClickParkingPlace(__x, svgId, linkedSensor))));
                case "Camera" :
                  let linkedCamera = objectType.linkedCamera;
                  return JsxRuntime.jsx(CameraObject$LumiFacilityMap.make, {
                    mapTransform: mapTransform,
                    objectTransform: transform,
                    objectStyle: ObjectStyle$LumiFacilityMap.mergeOpt(Stdlib_Option.flatMap(linkedCamera, cameraKey => Belt_Map.get(cameraStyles, cameraKey)), svgStyle),
                    scale: scale,
                    onClick: Stdlib_Option.map(mbOnClickCamera, onClickCamera => LumiReact.nonPropagatedMouseEvent(__x => onClickCamera(__x, svgId, linkedCamera)))
                  }, svgId);
                case "Display" :
                  let linkedDisplay = objectType.linkedDisplay;
                  return JsxRuntime.jsx(DisplayObject$LumiFacilityMap.make, {
                    mapTransform: mapTransform,
                    objectTransform: transform,
                    displayStyle: DisplayStyle$LumiFacilityMap.mergeOpt(Stdlib_Option.flatMap(linkedDisplay, displayKey => Belt_Map.get(displayStyles, displayKey)), Stdlib_Option.map(svgStyle, x => DisplayStyle$LumiFacilityMap.make(x, undefined))),
                    scale: scale,
                    onClick: Stdlib_Option.map(mbOnClickDisplay, onClickDisplay => LumiReact.nonPropagatedMouseEvent(__x => onClickDisplay(__x, svgId, linkedDisplay)))
                  }, svgId);
                case "Indicator" :
                  let linkedIndicator = objectType.linkedIndicator;
                  return JsxRuntime.jsx(IndicatorObject$LumiFacilityMap.make, {
                    mapTransform: mapTransform,
                    objectTransform: transform,
                    objectStyle: ObjectStyle$LumiFacilityMap.mergeOpt(Stdlib_Option.flatMap(linkedIndicator, indicatorKey => Belt_Map.get(indicatorStyles, indicatorKey)), svgStyle),
                    scale: scale,
                    onClick: Stdlib_Option.map(mbOnClickIndicator, onClickIndicator => LumiReact.nonPropagatedMouseEvent(__x => onClickIndicator(__x, svgId, linkedIndicator)))
                  }, svgId);
                default:
                  return mkMapObject(objectType.shape, undefined, undefined, undefined);
              }
            }),
            className: FacilityMap$LumiDocuments.ObjectType.Enum.className(objectTypeEnum)
          }, FacilityMap$LumiDocuments.ObjectType.Enum.stringCodec.toString(objectTypeEnum));
        }),
        LumiReact.renderOption(undefined, props.children, children => children)
      ],
      transform: LumiSVG.Transform.Matrix.fromM23f(ptz.transform)
    }),
    ref: Primitive_option.some(LumiReact.unsafeCallbackDomRef(elem => {
      svgRef.current = elem;
      Stdlib_Option.forEach(mbOnSvgElement, onSvgElement => onSvgElement(elem));
    })),
    className: "facility-map lumi-ptz",
    tabIndex: 0,
    onKeyDown: ptz.onKeyDown,
    onClick: props.onClickBackground,
    onContextMenu: ptz.onContextMenu,
    onMouseDown: props.onMouseDown,
    onMouseMove: props.onMouseMove,
    onMouseUp: props.onMouseUp,
    onPointerDown: ptz.onPointerDown,
    onPointerMove: ptz.onPointerMove,
    onPointerUp: ptz.onPointerUp,
    onPointerLeave: ptz.onPointerLeave,
    onWheel: ptz.onWheel,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: LumiSVG.ViewBox.Float.fromRect(aabb)
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = $$Map;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  SensorStyles,
  CameraStyles,
  IndicatorStyles,
  calculateScale,
  defaultOnClick,
  make,
}
/* SensorStyles Not a pure module */
